import { Field, Switch } from "@carbon6/c6-frontend-design";
import { FilterBar, FilterSearchInput, type FilterBarChip } from "@/shared/ui/filter";
import { appTextModes } from "@/shared/ui/text";
import {
  clearDatasetFilterAxis,
  datasetFilterChips,
  EMPTY_DATASET_FILTERS,
  type DatasetFilters,
} from "../../feature/datasetFilters";

type DatasetFilterBarProps = {
  filters: DatasetFilters;
  onChange: (next: DatasetFilters) => void;
};

/**
 * Datasets 목록의 조회 축.
 *
 * 축은 검색과 숨김 포함 둘뿐이지만 자리 · 크기는 공용 해부학을 그대로 따른다 — 다음 목록
 * 화면이 같은 모양으로 읽혀야 한다(규칙 §13). 행 1 컨트롤은 size 를 지정하지 않아 c6 기본(md)이다.
 */
export function DatasetFilterBar({ filters, onChange }: DatasetFilterBarProps) {
  const chips: FilterBarChip[] = datasetFilterChips(filters).map((chip) => ({
    key: chip.axis,
    label: chip.label,
    removeLabel: `${chip.label} 해제`,
    onRemove: () => onChange(clearDatasetFilterAxis(filters, chip.axis)),
  }));

  return (
    <FilterBar
      ariaLabel="Dataset 필터"
      chips={chips}
      search={
        <FilterSearchInput
          ariaLabel="Dataset 검색"
          placeholder="이름이나 원본 주소로 검색해 보세요."
          value={filters.search}
          onCommit={(search) => onChange({ ...filters, search })}
        />
      }
      onClearAll={() => onChange(EMPTY_DATASET_FILTERS)}
    >
      <Field
        label="숨긴 Dataset 포함"
        labelPlacement="end"
        layout="hug"
        textVariant={appTextModes["body-normal"]}
      >
        <Switch
          checked={filters.includeHidden}
          onChange={(event) => onChange({ ...filters, includeHidden: event.target.checked })}
        />
      </Field>
    </FilterBar>
  );
}
